import { getApi, graphApi, deleteApi, postApi, putApi } from "@/utils/http";

export async function createAuthLink(data) {
  return postApi(`/video/auth/batch/authLink`, data);
}

export async function getVideoAuthList(params) {
  try {
    const res = await getApi("/video/auth", params);
    if (res.code === 0) {
      return res;
    }
  } catch (err) {
    console.log(err);
  }
}

export async function getConfig() {
  try {
    const res = await getApi("/user/", { key: "vidpost_doc" });
    if (res.code === 0) {
      return res.data;
    }
  } catch (err) {
    console.log(err);
  }
}

export async function getAuthVersion(params) {
  try {
    const res = await getApi(`/video/auth/check/version?version=${params}`);
    if (res.code === 0) {
      return res?.data?.item;
    }
  } catch (err) {
    console.log(err);
  }
}
